import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.VUE_APP_MODE !== 'Production',
  state: {
    user: null,
    tokens: null,
    drawer: false,
    collectibles: null,
  },
  mutations: {
    SET_USER(state, payload) {
      state.user = payload;
    },
    SET_TOKENS(state, payload) {
      state.tokens = payload;
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },
    SET_COLLECTIBLES(state, payload) {
      state.collectibles = payload;
    },
  },
  actions: {
    setUser({ commit }, user) {
      commit('SET_USER', user);
    },
    setTokens({ commit }, tokens) {
      commit('SET_TOKENS', tokens);
    },
    setCollectibles({ commit }, collectibles) {
      commit('SET_COLLECTIBLES', collectibles);
    },
  },
  modules: {},
  plugins: [createPersistedState()],
});
